module.exports = __webpack_public_path__ + "static/budowa kanalu sprzedazy bezposredniej-74499e5bf25fe96e0fc5d8bcd5d044f4.jpg";